import { TermsConditions } from 'features/terms-conditions';

export const TermsConditionsRoute = () => <TermsConditions />;
